import React from 'react';
import PlatformServicePage from './PlatformServicePage';
const TwitterServices: React.FC = () => <PlatformServicePage platform="twitter" />;
export default TwitterServices;
